module.exports = __webpack_public_path__ + "static/media/scroll.0a07fefd.svg";